<script lang="ts">
	import { getTemplateService } from 'src/helpers/xt1_helpers/template_helpers';
	import TemplateInputSettings from '../Components/TemplateInputSettings.svelte';
	import type { Device } from 'src/types/Device';

	export let device: Device;

	const unit: 'C' | 'F' = (getTemplateService(device)?.settings?.temp_unit || 'C').toUpperCase();
	const min = unit == 'C' ? -5 : -23;
	const max = unit == 'C' ? 5 : 41;
</script>

<TemplateInputSettings
	{device}
	setting="temp_offset"
	{min}
	{max}
	unit={`°${unit}`}
	icon="far fa-thermometer-three-quarters"
/>
